module.exports = __webpack_public_path__ + "img/check2-all.043e81db.svg";